import React, { Component } from 'react'

import CartItem from './CartItem'
import { connect, useDispatch, useSelector } from 'react-redux';

import {

    Grid,
    Button,
    IconButton,
    Divider,
    Box,
    Stack,
    Typography,
    Avatar
} from "@mui/material";

import { FiShoppingCart, FiDollarSign } from 'react-icons/fi';
import { validaTotalGeral } from '../utils/functions';
import CartItemResumo from './CartItemResumo';
import Actions from '../constants/Actions';
import { removeFromCart, addItemQty, removeItemQty } from '../actions/index';
import todosProdutos from "../actions/produtos/todos-produtos";


const cardSx = {
    p: { xs: 2.5, md: 3 },
    borderRadius: 2.5,
    border: '1px solid',
    borderColor: 'grey.200',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    bgcolor: '#fff',
};

const ItemSumary = ({ title, value }) => {
    return (
        <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.95rem' }}>{title}</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: '0.95rem' }}>{value}</Typography>
        </Stack>

    )
}


const ItemContinue = ({ cartItems, IrFrete, fecharCarrinho }) => {
    return (
        <Stack spacing={1.5} alignItems={"center"} direction={"row"} justifyContent={"space-between"}>
            <Button
                color='error'
                onClick={fecharCarrinho}
                variant='outlined'
                sx={{
                    height: 42,
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 1.5,
                }}
            >
                Fechar
            </Button>
            <Button
                fullWidth
                disabled={cartItems.length > 0 ? false : true}
                onClick={IrFrete}
                variant='contained'
                sx={{
                    height: 42,
                    bgcolor: '#1a1a2e',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 1.5,
                    '&:hover': {
                        bgcolor: '#16213e',
                    },
                }}
            >
                Continuar
            </Button>
        </Stack>
    )
}


const Cart = ({ IrFrete }) => {

    const cartItems = useSelector(state => state.cartItems);
    const dadosPessoais = useSelector(state => state.dadosPessoais);
    const dadosEntrega = useSelector(state => state.dadosEntrega);
    const valorFrete = useSelector(state => state.valorFrete);
    const carrinho = useSelector(state => state.carrinho);
    const dispatch = useDispatch();

    const removerProdutoCarrinho = (product) => {
        dispatch(removeFromCart(product))
    }

    // const removerProdutoCarrinho = (product) => {
    //     window.location.reload();
    // }

    const adicionarQtdItemCarrinho = (product) => {
        dispatch(addItemQty(product))
        console.log('ação add', product)
    }

    const removerQtdItemCarrinho = (product) => {
        dispatch(removeItemQty(product))
        console.log('ação excluir', product)
        console.log('cartItems', cartItems)

    }

    const fecharCarrinho = () => {
        dispatch({ type: Actions.DRAWER_CARRINHO, drawerCarrinho: false });
        todosProdutos().then(res => {
            dispatch({ type: Actions.SET_TODOS_PRODUTOS, products: res.data.produtos });
        }).catch(err => console.log(err));
    }

    return (

        <Stack
            sx={{
                width: 600,
                maxWidth: '98%',
                mx: 'auto',
                py: 3,
                px: 3,
                height: '100%',
                bgcolor: '#f5f5f5',
                minHeight: '100vh',
            }}
            spacing={2.5}
            justifyContent={"space-between"}
            direction={"column"}
        >

            <Stack spacing={3}>
                <ItemContinue
                    cartItems={cartItems}
                    IrFrete={IrFrete}
                    fecharCarrinho={fecharCarrinho}
                />

                <Divider sx={{ borderColor: 'grey.200' }} />

                <Box sx={cardSx}>
                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
                        <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                            <FiShoppingCart size={18} />
                        </Avatar>
                        <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                            Itens do Carrinho
                        </Typography>
                    </Stack>

                    <Grid container spacing={1}>
                        {cartItems.length > 0 ? cartItems.map((cartItem) => (
                            <Grid item xs={12} key={cartItem.sku}>
                                <CartItemResumo cartItem={cartItem} removeFromCart={removerProdutoCarrinho} />
                            </Grid>
                        )) : (
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        textAlign: 'center',
                                        color: 'text.secondary',
                                        py: 4,
                                        fontSize: '0.95rem',
                                    }}
                                >
                                    Sem Produtos no carrinho
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            </Stack>

            <Box sx={cardSx}>
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
                    <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                        <FiDollarSign size={18} />
                    </Avatar>
                    <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                        Resumo
                    </Typography>
                </Stack>

                <Stack direction={"column"} spacing={1.5}>
                    <ItemSumary
                        title={'Subtotal'}
                        value={`R$${cartItems.reduce((acc, { regular_price, quantity_inc }) => {
                            let qty = 1;
                            let item = parseFloat(regular_price).toFixed(2)
                            let accumulator = parseFloat(acc).toFixed(2)
                            let res = parseFloat(item) * qty + parseFloat(accumulator)
                            return parseFloat(res).toFixed(2)
                        }, 0)}`}
                    />

                    <ItemSumary
                        title={'Frete'}
                        value={`R$ ${valorFrete}`}
                    />

                    <Divider sx={{ borderStyle: 'dashed', borderColor: 'grey.300' }} />

                    <ItemSumary
                        title={'Total Geral'}
                        value={`R$ ${validaTotalGeral(cartItems, valorFrete, 0)}`}
                    />
                </Stack>
            </Box>

        </Stack>

    )

}

export default Cart;
